import { ThemesManager } from '../features/reportThemes/ThemesManager'

export default function ReportThemes() {
  return <ThemesManager />
}
